var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.clickable)?_c('button',{staticClass:"list-row-container",on:{"click":function($event){return _vm.$emit('row-clicked')}}},[_vm._t("default")],2):_c('div',{staticClass:"list-row-container"},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }